<template>
  <a
    class="flex-shrink-0 relative cursor-pointer w-[670px] h-[377px] rounded-[15px] border border-solid border-[#E0E0E0] overflow-hidden"
    @click="handleClick"
  >
    <!-- 图片 -->
    <img :src="coverUrl" :alt="altText" class="w-full h-full object-cover" />

    <!-- 直播时间叠加层（右下角位置） -->
    <div
      v-if="liveTime"
      class="absolute right-[16px] bottom-[16px] py-[8px] px-[16px] bg-black/60 rounded-[8px] text-[24px] text-white whitespace-nowrap"
    >
      {{ liveTime }}
    </div>

    <!-- 已读标签 - 贴紧右上角 -->
    <ViewedBadge
      v-if="viewed"
      variant="corner"
      class="absolute top-[-1px] right-0"
    />
  </a>
</template>

<script lang="ts">
import ViewedBadge from './ViewedBadge.vue';
interface Props {
  materialId: string;
  coverUrl: string;
  jumpUrl: string;
  liveTime?: string;
  viewed: boolean;
  tags?: string[];
  altText?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  materialId: {
    key: "materialId",
    required: true,
    type: String
  },
  coverUrl: {
    key: "coverUrl",
    required: true,
    type: String
  },
  jumpUrl: {
    key: "jumpUrl",
    required: true,
    type: String
  },
  liveTime: {
    key: "liveTime",
    required: false,
    type: String
  },
  viewed: {
    key: "viewed",
    required: true,
    type: Boolean
  },
  tags: {
    key: "tags",
    required: false,
    type: Array,
    default: () => []
  },
  altText: {
    key: "altText",
    required: false,
    type: String,
    default: '直播'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  function handleClick() {
    emit('click', props.materialId, props.jumpUrl);
  }
  return {
    handleClick
  };
};
__sfc_main.components = Object.assign({
  ViewedBadge
}, __sfc_main.components);
export default __sfc_main;
</script>
